<template>
  <div>
       خرید دوره
  </div>
</template>

<script>
export default {
  name: "CourseBuyMobile"
}
</script>

<style scoped>

</style>